/**
 * Resource Analytics Services
 */
export * from './ResourceAnalyticsService';
import { ResourceAnalyticsService } from './ResourceAnalyticsService';
export function createAnalyticsServices(http, config) {
    return {
        resource: new ResourceAnalyticsService(http, config),
    };
}
//# sourceMappingURL=index.js.map